import * as React from 'react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { DetailsList, DetailsListLayoutMode, Selection, SelectionMode, IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { MarqueeSelection } from 'office-ui-fabric-react/lib/MarqueeSelection';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { HoverCard } from "office-ui-fabric-react/lib/index";
import { Text, Stack } from 'office-ui-fabric-react/lib';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { MyContext } from '../../../context';
import { Dialog, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import zipcelx from 'zipcelx';
import AlertBar from '../../CustomComponents/AlertBar';

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px'
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden'
            }
        }
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '20px',
        maxWidth: '20px'
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px'
    },
    selectionDetails: {
        marginBottom: '20px'
    }
});

const config = {
    filename: 'UserReport',
    sheet: {
        data: [
            [{
                value: "UserId",
                type: 'string'
            }, {
                value: 'UserName',
                type: 'string'
            }, {
                value: "DisplayName",
                type: 'string'
            }, {
                value: "License",
                type: 'string'
            }, {
                value: "Group Sync",
                type: 'string'
            }, {
                value: "Group Membership",
                type: 'string'
            }, {
                value: "RecordingRule",
                type: 'string'
            }, {
                value: "ReplayRule",
                type: 'string'
            }, {
                value: "AccessRule",
                type: 'string'
            }, {
                value: "AnalyticsRule",
                type: 'string'
            }, {
                value: "AddOnMsftTeamsVoice",
                type: 'string'
            }, {
                value: "AddOnMsftTeamsUC",
                type: 'string'
            }, {
                value: "AddOnAnalytics",
                type: 'string'
            }, {
                value: "AddOnAIEntry",
                type: 'string'
            }, {
                value: "AddOnFullChat",
                type: 'string'
            }, {
                value: "AddOnCaseManagement",
                type: 'string'
            }, {
                value: "AddOnZoom",
                type: 'string'
            }, {
                value: "AddOnGenesys",
                type: 'string'
            }, {
                value: "AddOnRingcentral",
                type: 'string'
            }, {
                value: "AddOnCloud9",
                type: 'string'
            }, {
                value: "AddOnDynamics",
                type: 'string'
            }, {
                value: "AddOnWebex",
                type: 'string'
            }, {
                value: "AddOnCompliance",
                type: 'string'
            }, {
                value: "AddOnQualityManagement",
                type: 'string'
            }, {
                value: "AddOnLeapXpert",
                type: 'string'
            }, {
                value: "AddOnEmail",
                type: 'string'
            },
            {
                value: "AddOnRealTimeTranscript",
                type: 'string'
            }
            ]
        ]
    }
};

//old storage options to get name for displaying in the table
const oldStorageOptions = [
    { key: "Unknown", text: "Unknown" },
    { key: "Emea", text: "EMEA GRS" },
    { key: "UkSouth", text: "UK South GRS" },
    { key: "Apac", text: "APAC GRS" },
    { key: "Americas", text: "Americas GRS" },
    { key: "Brazil", text: "Brazil GRS" },
    { key: "Canada", text: "Canada GRS" },
    { key: "Japan", text: "Japan GRS" },
    { key: "Switzerland", text: "Switzerland GRS" },
    { key: 'UAENorth', text: "UAE North GRS" },
    { key: "LrsEmea", text: "EMEA LRS" },
    { key: "LrsUkSouth", text: "UK South LRS" },
    { key: "LrsApac", text: "APAC LRS" },
    { key: "LrsAmericas", text: "Americas LRS" },
    { key: "LrsBrazil", text: "Brazil LRS" },
    { key: "LrsCanada", text: "Canada LRS" },
    { key: "LrsJapan", text: "Japan LRS" },
    { key: "LrsSwitzerland", text: "Switzerland LRS" },
    { key: 'LrsUAENorth', text: "UAE North LRS" },
    { key: "GrsSwiss", text: "Swiss GRS" },
    { key: "ZrsSingapore", text: "Singapore Zrs" },
    { key: "ApacSe", text: "APAC Southeast GRS" },
    { key: "S3Storage", text: "S3 Storage" },
    { key: "CustomStorage", text: "Own Storage" }
];


// Utility function to get rule name and append [Profile] if from profileData
function getRuleNameWithProfile(ruleId, profileData = [], ruleData = []) {
    let rule = (profileData || []).find(r => r.id === ruleId);
    if (rule) {
        return `${rule.name} [Profile]`;
    }
    rule = (ruleData || []).find(r => r.id === ruleId);
    if (rule) {
        return rule.name;
    }
    return ruleId; // fallback to id if not found
}

export default class UserList extends React.Component {
    // _selection and _allItems are handled in constructor or as needed

    constructor(props) {
        super(props);

        let columns = [
            {
                key: 'column1',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "options")}</>)}</MyContext.Consumer>,
                className: classNames.fileIconCell,
                iconClassName: classNames.fileIconHeaderIcon,
                ariaLabel: 'Column operations for File type, Press to sort on File type',
                isIconOnly: true,
                fieldName: 'name',
                minWidth: 16,
                maxWidth: 16,
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <a style={{ cursor: "pointer" }} onClick={() => { this.props.func(item, 0) }}><Icon iconName={"Settings"} /></a>
                }
            },
            {
                key: 'column2',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "name")}</>)}</MyContext.Consumer>,
                fieldName: 'name',
                isResizable: true,
                minWidth: 120,
                data: 'number',
                isSorted: true,
                isSortedDescending: false,
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    const expandingCardProps =
                    {
                        onRenderCompactCard: () => {
                            return (
                                <MyContext.Consumer>
                                    {(context) => (
                                        <div>
                                            <div className="content-container">
                                                <div className="padding-default-b">
                                                    <mgt-person show-name={true} user-id={item.userId} person-card="hover"></mgt-person>
                                                </div>
                                                <ul className="ul-flat">
                                                    <li>{context.getTranslation("configuration", "email")}: <a>{item.username}</a> </li>
                                                </ul>
                                                <ul className="ul-flat">
                                                    <li>{context.getTranslation("configuration", "id")}: <a>{item.userId}</a> </li>
                                                </ul>
                                            </div>
                                        </div>
                                    )
                                    }
                                </MyContext.Consumer>
                            );
                        },
                        onRenderExpandedCard: () => {
                            var nameRecordingRules = "";
                            var nameReplayRules = "";
                            var nameAccessRules = "";
                            var nameAnalyticsRules = "";
                            nameRecordingRules = getRuleNameWithProfile(
                                item.recordingRules,
                                this.props.profileData,
                                this.props.ruleData
                            );
                            this.props.ruleData.forEach(function (aRule) {
                                if (aRule.id === item.analytics) {
                                    nameAnalyticsRules = aRule.name;
                                } else if (aRule.id === item.access) {
                                    nameAccessRules = aRule.name;
                                } else if (aRule.id === item.replay) {
                                    nameReplayRules = aRule.name;
                                }
                            });

                            return (
                                <MyContext.Consumer>
                                    {(context) => (

                                        <div className="padding-default-b">
                                            <Stack styles={{ paddingLeft: 10 }}>
                                                <Stack.Item styles={{ root: { paddingLeft: "10px" } }}>
                                                    <Text>{context.getTranslation("configuration", "assignedRules")}</Text>
                                                    <ul>
                                                        <li> {context.getTranslation("configuration", "recordingRules")}: {nameRecordingRules}</li>
                                                        <li> {context.getTranslation("configuration", "replayRules")}: {nameReplayRules}</li>
                                                        <li> {context.getTranslation("configuration", "accessRules")}: {nameAccessRules}</li>
                                                        <li> {context.getTranslation("configuration", "analyticsRules")}: {nameAnalyticsRules}</li>
                                                    </ul>
                                                </Stack.Item>
                                            </Stack>
                                        </div>
                                    )
                                    }
                                </MyContext.Consumer>
                            );
                        },
                        renderData: item
                    };

                    return <HoverCard expandingCardProps={expandingCardProps} instantOpenOnClick={true}>
                        <a style={{ cursor: "pointer" }}>{item.name}</a>
                    </HoverCard>;
                }
            }, {
                key: 'column3',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "username")}</>)}</MyContext.Consumer>,
                fieldName: 'username',
                minWidth: 130,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.username}</span>;
                }
            },

            {
                key: 'column4',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "license")}</>)}</MyContext.Consumer>,
                fieldName: 'license',
                minWidth: 200,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    switch (item.license) {
                        case "6":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceVoiceRecording")}</>)}</MyContext.Consumer>)
                        case "7":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceVoiceAnalytics")}</>)}</MyContext.Consumer>)
                        case "1":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceRecording")}</>)}</MyContext.Consumer>)
                        case "2":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceRecordingAnalytics")}</>)}</MyContext.Consumer>)
                        case "8":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartVoice")}</>)}</MyContext.Consumer>)
                        case "9":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartVoiceAnalytics")}</>)}</MyContext.Consumer>)
                        case "3":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartRecording")}</>)}</MyContext.Consumer>)
                        case "4":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartRecordingAnalytics")}</>)}</MyContext.Consumer>)
                        case "5":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "chatRecordingStandalone")}</>)}</MyContext.Consumer>)
                        case "10":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseRecordingInsinghtsAI")}</>)}</MyContext.Consumer>)
                        case "11":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseSmartBase")}</>)}</MyContext.Consumer>)
                        case "12":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseComplianceBase")}</>)}</MyContext.Consumer>)
                        case "13":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseEntryVoiceRecording")}</>)}</MyContext.Consumer>)


                    }
                }
            },
            {
                key: 'column17',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "storage")}</>)}</MyContext.Consumer>,
                fieldName: 'storageId',
                minWidth: 90,
                isResizable: true,
                data: 'text',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    let displayName = "";
                    //check if old storage is still there only if new storage is not set yet
                    if (item.regionalStorageLocation && !item.storageId) {
                        displayName = oldStorageOptions.map((storage) => {
                            if ((storage.key === item.regionalStorageLocation))
                                return storage.text;
                        });
                    } else if (this.props.storagesList) {
                        displayName = this.props.storagesList.map((storage) => {
                            if ((storage.id === item.storageId) && (storage.id !== ""))
                                return storage.displayName;
                        });
                    }

                    return displayName;

                }
            },
            {
                key: 'column5',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "groupSync")}</>)}</MyContext.Consumer>,
                fieldName: 'groupName',
                minWidth: 100,
                isResizable: true,
                data: 'text',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.groupName}</span>;
                }
            },
            {
                key: 'groupMembershipColumn',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "groupMembership")}</>)}</MyContext.Consumer>,
                fieldName: 'groupMembership',
                minWidth: 150,
                isResizable: true,
                data: 'text',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.groupMembership}</span>;

                }
            },
            {
                key: 'column6',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "usersRecordingRuleCol")}</>)}</MyContext.Consumer>,
                fieldName: 'recordingRules',
                minWidth: 120,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    const name = getRuleNameWithProfile(
                        item.recordingRules,
                        this.props.profileData,
                        this.props.ruleData
                    );
                    return <span>{name}</span>
                }
            },
            {
                key: 'column7',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "replayRule")}</>)}</MyContext.Consumer>,
                fieldName: 'replay',
                minWidth: 120,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    var name = item.replay;
                    this.props.ruleData.forEach(function (aRule) {
                        if (aRule.id === item.replay) {
                            name = aRule.name;
                        };
                    });
                    return <span>{name}</span>;
                }
            },
            {
                key: 'column8',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "acccessRule")}</>)}</MyContext.Consumer>,
                fieldName: 'access',
                minWidth: 120,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    var name = item.access;
                    this.props.ruleData.forEach(function (aRule) {
                        if (aRule.id === item.access) {
                            name = aRule.name;
                        };
                    });
                    return <span>{name}</span>;
                }
            },
            {
                key: 'column9',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "analyticsRules")}</>)}</MyContext.Consumer>,
                fieldName: 'analytics',
                minWidth: 120,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    var name = item.analytics;
                    this.props.ruleData.forEach(function (aRule) {
                        if (aRule.id === item.analytics) {
                            name = aRule.name;
                        };
                    });
                    return <span>{name}</span>;
                }
            }
        ];

        if (this.props.tenantData.syncEmployeeDataFromGraph) {
            columns.splice(3, 0, { // Insert after username column 
                key: 'onPremisesSamAccountName',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "onPremisesSamAccountName")}</>)}</MyContext.Consumer>,
                fieldName: 'onPremisesSamAccountName',
                minWidth: 120,
                calculatedWidth: 241,
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                onRender: (item) => <span>{item.onPremisesSamAccountName}</span>
            });

            columns.splice(3, 0, { // Insert after username column 
                key: 'employeeId',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "employeeId")}</>)}</MyContext.Consumer>,
                fieldName: 'employeeId',
                minWidth: 120,
                calculatedWidth: 241,
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                onRender: (item) => <span>{item.employeeId}</span>
            });
        }
        if (this.props.tenantData.addOnMsftTeamsVoice) {
            columns.push(
                {
                    key: 'addOnMsftTeamsVoice',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnMsftTeamsVoice")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnMsftTeamsVoice',
                    minWidth: 150,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnMsftTeamsVoice ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData?.addOnMsftTeamsUC) {
            columns.push(
                {
                    key: 'addOnMsftTeamsUC',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnMsftTeamsUC")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnMsftTeamsUC',
                    minWidth: 150,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnMsftTeamsUC ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnAnalytics) {
            columns.push(
                {
                    key: 'column10',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnAnalytics")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnAnalytics',
                    minWidth: 120,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnAnalytics ? "true" : "false"}</span>;
                    }
                }
            );
        }
        if (this.props.tenantData.addOnAIEntry) {
            columns.push(
                {
                    key: 'columnAddOnAIEntry',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnAIEntry")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnAIEntry',
                    minWidth: 120,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnAIEntry ? "true" : "false"}</span>;
                    }
                }
            );
        }
        if (this.props.tenantData.addOnFullChat) {
            columns.push(
                {
                    key: 'column11',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnFullChat")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnFullChat',
                    minWidth: 160,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnFullChat ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.userRules.addOnCaseManagement) {
            columns.push(
                {
                    key: 'addOnCaseManagement',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnCaseManagement")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnCaseManagement',
                    minWidth: 160,
                    isResizable: true,
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnCaseManagement !== undefined ? item.addOnCaseManagement.toString() : ""}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnZoom) {
            columns.push(
                {
                    key: 'column12',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnZoom")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnZoom',
                    minWidth: 120,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnZoom ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnGenesys) {
            columns.push(
                {
                    key: 'column13',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnGenesys")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnGenesys',
                    minWidth: 130,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnGenesys ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnRingcentral) {
            columns.push(
                {
                    key: 'column14',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnRingcentral")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnRingcentral',
                    minWidth: 150,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnRingcentral ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnCloud9) {
            columns.push(
                {
                    key: 'addOnCloud9',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnCloud9")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnCloud9',
                    minWidth: 150,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnCloud9 ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnDynamics) {
            columns.push(
                {
                    key: 'column15',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnDynamics")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnDynamics',
                    minWidth: 150,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnDynamics ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnCompliance) {
            columns.push(
                {
                    key: 'column16',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnCompliance")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnCompliance',
                    minWidth: 120,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnCompliance ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnQualityManagement) {
            columns.push(
                {
                    key: 'addOnQualityManagement',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnQualityManagement")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnQualityManagement',
                    minWidth: 120,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnQualityManagement ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnLeapXpert) {
            columns.push(
                {
                    key: 'column18',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnLeapXpert")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnLeapXpert',
                    minWidth: 120,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnLeapXpert ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnWebex) {
            columns.push(
                {
                    key: 'columnWebex',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnWebex")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnWebex',
                    minWidth: 120,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnWebex ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnEmail) {
            columns.push(
                {
                    key: 'column19',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnEmail")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnEmail',
                    minWidth: 120,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnEmail ? "true" : "false"}</span>;
                    }
                });
        }

        columns.push(
            {
                key: 'addOnRealTimeTranscript',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnRealTimeTranscript")}</>)}</MyContext.Consumer>,
                fieldName: 'addOnRealTimeTranscript',
                minWidth: 120,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.addOnRealTimeTranscript ? "true" : "false"}</span>;
                }
            });


        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    selectionDetails: this._getSelectionDetails(),
                    warningMessage: ""

                });
            }
        });

        this.state = {
            columns: columns,
            selectionDetails: this._getSelectionDetails(),
            isModalSelection: true,
            isCompactMode: true,
            items: this._allItems,
            filter: "",
            isDialogOpen: false,
            isAddAppUserOpen: false,
            warningMessage: ""
        };

    }

    _dialogClose = () => this.setState({ isDialogOpen: false })


    // Data for CommandBar
    getItems = () => {

        let items = [];
        if (this.props.tenantData.licenseCompVoice != null && this.props.tenantData.licenseCompVoice.bought) {
            items.push(
                {
                    key: 'ComplianceVoice',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceVoiceRecording")}({this.props.tenantData.licenseCompVoice.used}/{this.props.tenantData.licenseCompVoice.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'Microphone'
                    },
                    onClick: () => { this.props.func(null, 15) }
                }
            );
        }
        if (this.props.tenantData.licenseComp != null && this.props.tenantData.licenseComp.bought) {
            items.push(
                {
                    key: 'ComplianceUC',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceRecording")}({this.props.tenantData.licenseComp.used}/{this.props.tenantData.licenseComp.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'Camera'
                    },
                    onClick: () => { this.props.func(null, 2) }
                }
            );
        }
        if (this.props.tenantData.licenseSmartVoice != null && this.props.tenantData.licenseSmartVoice.bought) {
            items.push(
                {
                    key: 'SmartVoice',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartVoice")} ({this.props.tenantData.licenseSmartVoice.used}/{this.props.tenantData.licenseSmartVoice.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'Microphone'
                    },
                    onClick: () => { this.props.func(null, 17) }
                }
            );
        }
        if (this.props.tenantData.licenseSmart != null && this.props.tenantData.licenseSmart.bought) {
            items.push(
                {
                    key: 'SmartRecording',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartRecording")}({this.props.tenantData.licenseSmart.used}/{this.props.tenantData.licenseSmart.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'Microphone'
                    },
                    onClick: () => { this.props.func(null, 6) }
                }
            );
        }
        if (this.props.tenantData.licenseEntryVoiceRecording != null && this.props.tenantData.licenseEntryVoiceRecording.bought) {
            items.push(
                {
                    key: 'licenseEntryVoiceRecording',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseEntryVoiceRecording")}({this.props.tenantData?.licenseEntryVoiceRecording?.used}/{this.props.tenantData?.licenseEntryVoiceRecording?.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 36) }
                }
            );
        }
        if (this.props.tenantData.licenseSmartBase != null && this.props.tenantData.licenseSmartBase.bought) {
            items.push(
                {
                    key: 'ComplianceVoiceNoRec',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseSmartBase")}({this.props.tenantData?.licenseSmartBase?.used}/{this.props.tenantData?.licenseSmartBase?.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 32) }
                }
            );
        }
        if (this.props.tenantData.licenseComplianceBase != null && this.props.tenantData.licenseComplianceBase.bought) {
            items.push(
                {
                    key: 'ComplianceUCNoRec',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseComplianceBase")}({this.props.tenantData?.licenseComplianceBase?.used}/{this.props.tenantData?.licenseComplianceBase?.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 34) }
                }
            );
        }

        if (this.props.tenantData.licenseAna != null && this.props.tenantData.licenseAna.bought) {
            items.push(
                {
                    key: 'Analytics',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "chatRecordingStandalone")} ({this.props.tenantData.licenseAna.used}/{this.props.tenantData.licenseAna.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'Upload'
                    },
                    onClick: () => { this.props.func(null, 8) }
                }
            );
        }
        if (this.props.tenantData.licenseRecordingInsinghtsAI != null && this.props.tenantData.licenseRecordingInsinghtsAI.bought) {
            items.push(
                {
                    key: 'LicenseRecordingInsinghtsAI',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseRecordingInsinghtsAI")}({this.props.tenantData.licenseRecordingInsinghtsAI.used}/{this.props.tenantData.licenseRecordingInsinghtsAI.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 29) }
                }
            );
        }
        if (this.props.tenantData.licenseCompVoiceAna != null && this.props.tenantData.licenseCompVoiceAna.bought) {
            items.push(
                {
                    key: 'ComplianceVoiceAna',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceVoiceAnalytics")}({this.props.tenantData.licenseCompVoiceAna.used}/{this.props.tenantData.licenseCompVoiceAna.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 16) }
                }
            );
        }
        if (this.props.tenantData.licenseCompAna != null && this.props.tenantData.licenseCompAna.bought) {
            items.push(
                {
                    key: 'ComplianceUCAnalytics',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceRecordingAnalytics")}({this.props.tenantData.licenseCompAna.used}/{this.props.tenantData.licenseCompAna.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 5) }
                }
            );
        }

        if (this.props.tenantData.licenseSmartVoiceAna != null && this.props.tenantData.licenseSmartVoiceAna.bought) {
            items.push(
                {
                    key: 'SmartVoiceAnalytics',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartVoiceAnalytics")}({this.props.tenantData.licenseSmartVoiceAna.used}/{this.props.tenantData.licenseSmartVoiceAna.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 18) }
                }
            );
        }

        if (this.props.tenantData.licenseSmartAna != null && this.props.tenantData.licenseSmartAna.bought) {
            items.push(
                {
                    key: 'SmartRecordingAnalytics',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartRecordingAnalytics")}({this.props.tenantData.licenseSmartAna.used}/{this.props.tenantData.licenseSmartAna.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 7) }
                }
            );
        }



        let addButton = {
            key: 'add',
            name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "addUser")}</>)}</MyContext.Consumer>,
            iconProps: { iconName: 'Add' },
            subMenuProps: {
                items: items
            }
        };

        let editButton = {
            key: 'Edit',
            name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "edit")}</>)}</MyContext.Consumer>,
            onClick: () => { this.openMultySelect() },
            iconProps: {
                iconName: 'Edit'
            }
        };

        let searchField = {
            key: 'text',
            name: 'text',
            onClick: () => console.log('Rename'),
            onRender: () => { return <div style={{ padding: "4px" }} > <TextField onChange={this._onChangeText} /> </div> },
            iconProps: {
                iconName: 'Edit'
            }
        };

        let download = {
            key: 'download',
            iconProps: { iconName: 'Download' },
            name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "exportReport")}</>)}</MyContext.Consumer>,
            onClick: () => { this._onExport() }
        }

        if (this.props.userRules.ruleAccess != null && this.props.userRules.ruleAccess.confAddUser) {
            return [addButton, editButton, searchField, download];
        } else {
            return [editButton, searchField, download];
        }
    };
    render() {
        const { columns, isModalSelection } = this.state;
        this.ruleData = this.props.ruleData;
        this.userData = this._generateDocuments(this.props.data || [], this.state.filter);
        return (
            <MyContext.Consumer>
                {(context) => (
                    <Fabric>
                        <Dialog
                            isOpen={this.state.isDialogOpen}
                            type={DialogType.close}
                            onDismiss={this._dialogClose.bind(this)}
                            title='Excel export'
                            subText='Excel file created and downloaded to your favourite directory'
                            isBlocking={false}
                            closeButtonAriaLabel='Close'
                        />

                        <div className={classNames.controlWrapper}>
                        </div>
                        <CommandBar
                            items={this.getItems()}
                            ariaLabel={context.getTranslation("common", "navigateBetweenCommands")}
                        />
                        {/*Warning and error message*/}
                        <AlertBar
                            message={this.state.warningMessage}
                            alertType={this.state.alertType}
                            clearAlert={() => { this.setState({ warningMessage: "" }) }}
                        />

                        <MarqueeSelection selection={this._selection}>
                            <DetailsList
                                items={this.userData}
                                compact={false}
                                columns={columns}
                                selectionMode={isModalSelection ? SelectionMode.multiple : SelectionMode.none}
                                setKey="set"
                                layoutMode={DetailsListLayoutMode.fixedColumns}
                                isHeaderVisible={true}
                                selection={this._selection}
                                selectionPreservedOnEmptyClick={true}
                                onItemInvoked={this._onItemInvoked}
                                enterModalSelectionOnTouch={true}
                                ariaLabelForSelectionColumn="Toggle selection"
                                ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                            />
                        </MarqueeSelection>
                    </Fabric>
                )
                }
            </MyContext.Consumer>

        );
    }

    _onExport = (ev) => {

        var itemList = [];

        //add to header only if available
        let headerRow = config.sheet.data[0].slice();
        if (this.props.tenantData.syncEmployeeDataFromGraph) {
            headerRow.splice(3, 0, { value: "OnPremisesSamAccountName", type: 'string' });
            headerRow.splice(3, 0, { value: "EmployeeId", type: 'string' });
        }
        itemList.push(headerRow);

        this.userData.forEach((anItem) => {
            let nameRecording = getRuleNameWithProfile(
                anItem.recordingRules,
                this.props.profileData,
                this.props.ruleData
            );
            let nameReplay = anItem.replay;
            this.props.ruleData.forEach(function (aRule) {
                if (aRule.id === anItem.replay) {
                    nameReplay = aRule.name;
                };
            });
            let nameAccess = anItem.access;
            this.props.ruleData.forEach(function (aRule) {
                if (aRule.id === anItem.access) {
                    nameAccess = aRule.name;
                };
            });
            let nameAnalytics = anItem.analytics;
            this.props.ruleData.forEach(function (aRule) {
                if (aRule.id === anItem.analytics) {
                    nameAnalytics = aRule.name;
                };
            });

            let dataRow = [
                {
                    value: anItem.userId,
                    type: 'string'
                }, {
                    value: anItem.username,
                    type: 'string'
                }, {
                    value: anItem.name,
                    type: 'string'
                }, {
                    value: anItem.license,
                    type: 'number'
                },
                {
                    value: anItem.groupName,
                    type: 'string'
                },
                {
                    value: anItem.groupMembership,
                    type: 'string'
                },
                {
                    value: nameRecording,
                    type: 'string'
                },
                {
                    value: nameReplay,
                    type: 'string'
                },
                {
                    value: nameAccess,
                    type: 'string'
                },
                {
                    value: nameAnalytics,
                    type: 'string'
                },
                {
                    value: anItem.addOnMsftTeamsVoice,
                    type: 'string'
                },
                {
                    value: anItem.addOnMsftTeamsUC,
                    type: 'string'
                },
                {
                    value: anItem.addOnAnalytics,
                    type: 'string'
                },
                {
                    value: anItem.addOnAIEntry,
                    type: 'string'
                },
                {
                    value: anItem.addOnFullChat,
                    type: 'string'
                },
                {
                    value: anItem.addOnCaseManagement,
                    type: 'string'
                },
                {
                    value: anItem.addOnZoom,
                    type: 'string'
                },
                {
                    value: anItem.addOnGenesys,
                    type: 'string'
                },
                {
                    value: anItem.addOnRingcentral,
                    type: 'string'
                },
                {
                    value: anItem.addOnCloud9,
                    type: 'string'
                },
                {
                    value: anItem.addOnDynamics,
                    type: 'string'
                },
                {
                    value: anItem.addOnWebex,
                    type: 'string'
                },
                {
                    value: anItem.addOnCompliance,
                    type: 'string'
                },
                {
                    value: anItem.addOnQualityManagement,
                    type: 'string'
                },
                {
                    value: anItem.addOnLeapXpert,
                    type: 'string'
                },
                {
                    value: anItem.addOnEmail,
                    type: 'string'
                },
                {
                    value: anItem.addOnRealTimeTranscript,
                    type: 'string'
                }
            ];

            // Conditionally insert fields after DisplayName (index 3)
            if (this.props.tenantData.syncEmployeeDataFromGraph) {
                dataRow.splice(3, 0, { value: anItem.onPremisesSamAccountName || '', type: 'string' });
                dataRow.splice(3, 0, { value: anItem.employeeId || '', type: 'string' });
            }

            itemList.push(dataRow);
        });
        config.sheet.data = itemList;
        zipcelx(config)
        this.setState({ isDialogOpen: true });
    }

    componentDidUpdate(previousProps, previousState) {
        if (previousState.isModalSelection !== this.state.isModalSelection && !this.state.isModalSelection) {
            this._selection.setAllSelected(false);
        }
    }

    _onChangeCompactMode = (ev, checked) => {
        this.setState({ isCompactMode: checked });
    };

    _onChangeModalSelection = (ev, checked) => {
        this.setState({ isModalSelection: checked });
    };

    _onChangeText = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string): void => {
        const lowerText = text ? text.toLocaleLowerCase() : "";
        this.userData = this.userData.filter(i =>
            (i.name && (i.name.includes(text) || i.name.toLocaleLowerCase().includes(lowerText))) ||
            (i.employeeId && (i.employeeId.includes(text) || i.employeeId.toLocaleLowerCase().includes(lowerText))) ||
            (i.onPremisesSamAccountName && (i.onPremisesSamAccountName.includes(text) || i.onPremisesSamAccountName.toLocaleLowerCase().includes(lowerText))) ||
            (i.username && (i.username.includes(text) || i.username.toLocaleLowerCase().includes(lowerText)))
        );
        this.setState({ filter: text });
    };

    openMultySelect = () => {
        if (this._selection.getSelection().length > 0) {
            this.props.func(this._selection.getSelection(), 0);
        } else {
            //no element selected
            this.setState({
                warningMessage: "Select an user",
                alertType: "warning"
            })
        }
    };

    _getSelectionDetails(): string {
        const selectionCount = this._selection.getSelectedCount();

        switch (selectionCount) {
            case 0:
                return '';
            case 1:
                return '';
            default:
                return `${selectionCount} Items selected`;
        }
    }

    _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { columns } = this.state;
        const newColumns: IColumn[] = columns.slice();
        const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        this.setState({
            columns: newColumns,
        });
    };

    _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
        const key = columnKey;
        return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
    };

    _generateDocuments(DataArr, text) {
        if (!Array.isArray(DataArr)) {
            return [];
        }
        const lowerText = text ? text.toLocaleLowerCase() : "";
        // First filter
        let DataArrFiltered = DataArr.filter(i =>
            i.name != null && (
                (i.name && (i.name.includes(text) || i.name.toLocaleLowerCase().includes(lowerText))) ||
                (i.employeeId && (i.employeeId.includes(text) || i.employeeId.toLocaleLowerCase().includes(lowerText))) ||
                (i.onPremisesSamAccountName && (i.onPremisesSamAccountName.includes(text) || i.onPremisesSamAccountName.toLocaleLowerCase().includes(lowerText))) ||
                (i.username && (i.username.includes(text) || i.username.toLocaleLowerCase().includes(lowerText)))
            )
        );
        // Then sort
        let newColumns = this.state.columns;
        newColumns.forEach((newCol: IColumn) => {
            if (newCol.isSorted) {
                DataArrFiltered = this._copyAndSort(DataArrFiltered, newCol.fieldName, newCol.isSortedDescending);
            }
        });
        return DataArrFiltered;
    }
}